<div class="container">
  <h1>404</h1>
  <span>Página não encontrada</span>

  <p>Desculpe, não foi possível encontrar esta página...</p>
</div>
